<template>
<div id="print-calc" class="wph-print-calc wph-container wph-p-4 wph-pb-8 wph-mx-auto wph-overflow-hidden">
  <app-steps :show-cart="showCart" :cart-total="total"
    @go-to-cart="showCart = true"
    @go-to-editor="showCart = false"
    class="wph-mb-8"
  ></app-steps>
  <cart-item-editor v-if="!showCart" @go-to-cart="showCart = true" />
  <template v-else>
    <order-summary :cart-has-bags="cartHasBags" @go-to-editor="showCart = false" />

    <div v-if="cartItems.length" class="md:wph-flex wph-mt-12 wph-shadow-xl">
      <div class="wph-flex wph-flex-col md:wph-w-1/4 wph-pt-8 wph-pb-5 wph-px-4 lg:wph-px-6 wph-bg-accent-dark wph-text-white md:wph-rounded-l-lg"
      >
        <div>
          <p class="wph-text-gray-200 wph-mb-6 wph-font-bold">Сумма заказа:</p>
          <div class="wph-flex wph-mb-2">
            <div class="wph-flex-1 wph-text-gray-400">Тираж: </div>
            <div class="wph-font-bold wph-text-right">
              {{ totals.current | money }}
              <sub v-show="totals.current < totals.max"
                   class="wph-line-through wph-block wph-ml-1 wph-mb-3 wph-text-gray-500"
              >
                {{ totals.max | money }}
              </sub>
            </div>
          </div>
          <div class="wph-flex wph-mb-2">
            <div class="wph-flex-1 wph-text-gray-400">Нанесение: </div>
            <div class="wph-font-bold wph-text-right">
              {{ totals.print | money }}
            </div>
          </div>
          <div class="wph-flex wph-mb-2">
            <div class="wph-flex-1 wph-text-gray-400">Упаковка: </div>
            <div class="wph-font-bold wph-text-right">
              {{ totals.packing | money }}
            </div>
          </div>
          <div v-if="orderUrgencyPrice" class="wph-flex wph-mb-2">
            <div class="wph-flex-1 wph-text-gray-400">Срочность: </div>
            <div class="wph-font-bold wph-text-right">
              {{ orderUrgencyPrice | money }}
            </div>
          </div>
        </div>
        <div class="wph-mt-auto wph-text-lg">
          <p class="wph-mt-6 wph-pt-4 wph-border-t wph-border-gray-600 wph-text-xl wph-text-right">Итого по заказу:<br><span class="wph-text-5xl">{{ total | money }}</span></p>
        </div>
      </div>
      <app-send url="send-order"
                v-slot="{
                  sending,
                  response,
                  error,

                  send,
                }"
      >
        <div class="wph-flex wph-flex-col md:wph-w-3/4 wph-pt-8 md:wph-rounded-r-lg wph-border-b-4 wph-border-accent-dark">
          <div class="wph-flex-1 wph-px-4 lg:wph-px-6">
            <p class="wph-mb-6 wph-pb-4 wph-border-b wph-border-solid wph-border-accent-dark wph-text-accent-dark">Укажите Ваши контактные данные для заказа</p>
            <div class="lg:wph-flex wph-flex-wrap wph--mx-4">
              <div class="wph-px-4 lg:wph-w-1/2">
                <div :class="{ 'wph-with-error': error.response.data && error.response.data.errors['contact.name'] }">
                  <label for="name-input" class="wph-text-sm wph-mb-1 wph-text-accent-dark">Ваше имя</label>
                  <input type="text" v-model="name" id="name-input" class="wph-block wph-w-full">
                  <div v-if="error.response.data && error.response.data.errors['contact.name']"
                       class="wph-text-xs wph-mt-1"
                  >{{ error.response.data.errors['contact.name'][0] }}</div>
                </div>
              </div>
              <div class="wph-mt-4 wph-px-4 lg:wph-w-1/2 lg:wph-mt-0">
                <div :class="{ 'wph-with-error': error.response.data && error.response.data.errors['contact.email'] }">
                  <label for="email-input" class="wph-text-sm wph-mb-1 wph-text-accent-dark">Ваш Email</label>
                  <input type="text" v-model="email" id="email-input" class="wph-block wph-w-full">
                  <div v-if="error.response.data && error.response.data.errors['contact.email']"
                       class="wph-text-xs wph-mt-1"
                  >{{ error.response.data.errors['contact.email'][0] }}</div>
                </div>
              </div>
              <div class="wph-mt-4 wph-px-4 lg:wph-w-1/2">
                <div :class="{ 'wph-with-error': error.response.data && error.response.data.errors['contact.phone'] }">
                  <label for="phone-input" class="wph-text-sm wph-mb-1 wph-text-accent-dark">Ваш телефон</label>
                  <input type="text" v-model="phone" id="phone-input" class="wph-block wph-w-full">
                  <div v-if="error.response.data && error.response.data.errors['contact.phone']"
                       class="wph-text-xs wph-mt-1"
                  >{{ error.response.data.errors['contact.phone'][0] }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="wph-mt-6 wph-py-6 wph-px-4 lg:wph-px-6 wph-bg-blue-lightest">
            <p v-if="response && response.status === 200" style="color: #41b883;">
              Спасибо, Ваш заказ успешно отправлен! Мы свяжемся с Вами в ближайшее время.
            </p>
            <button v-else
                    role="button" class="wph-button"
                    @click="send(makeOrderData())"
                    :disabled="sending"
            >{{ sending ? 'Подождите' : 'Отправить заказ' }}</button>
          </div>
        </div>
      </app-send>
    </div>
  </template>
</div>
</template>

<script>
import './assets/css/calc.css'
import Steps from './components/Steps'
import CartItemEditor from './components/CartItemEditor'
import OrderSummary from './components/OrderSummary'
import Send from './components/requests/Send'

export default {
  name: 'app',
  components: {
    CartItemEditor,
    OrderSummary,
    AppSend: Send,
    AppSteps: Steps,
  },
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      showCart: false,
    }
  },
  computed: {
    cartItems() {
      return this.$store.state.cart.items
    },
    cartHasBags() {
      return this.cartItems.filter((item) => item.type.id === 'bags').length > 0
    },
    totals() {
      const result = {
        max: 0,
        current: 0,
        print: 0,
        packing: 0,
      }
      this.cartItems.reduce((totals, item) => {
        totals.max += item.calculations.totals.max
        totals.current += item.calculations.totals.current
        totals.print += item.calculations.totals.print
        totals.packing += item.calculations.totals.packing
        return totals
      }, result)
      return result
    },
    orderUrgencyPrice() {
      const orderUrgencyMultiplier = this.$store.state.order.urgencyRate
        ? this.$store.state.order.urgencyRate.multiplier[this.cartHasBags ? 'bags' : 'textile'] - 1
        : 0
      return Math.ceil((this.totals.current + this.totals.print + this.totals.packing) * orderUrgencyMultiplier)
    },
    total() {
      return this.totals.current + this.totals.print + this.totals.packing + this.orderUrgencyPrice
    },
  },
  methods: {
    addCartItem() {
      this.$store.commit('addCartItem')
    },
    makeOrderData() {
      return {
        cartItems: this.cartItems,
        urgency: {
          isUrgent: this.$store.state.order.isUrgent,
          urgencyRate: this.$store.state.order.urgencyRate,
          urgencyPrice: this.orderUrgencyPrice,
        },
        totals: this.totals,
        total: this.total,
        contact: {
          name: this.name,
          email: this.email,
          phone: this.phone,
        },
      }
    },
  },
}
</script>